import React from 'react'
import RatingStars from 'src/widgets/RatingStars/RatingStars'

export default function Staffv2Template({
  viewOnly = false,
  ratingData,
  onChange,
  submittedRating,
}) {
  const getTotalRating = () => {
    const {
      punctuality_attendance_and_time_keeping,
      devotion_to_duty,
      team_spirit,
      appearance_and_bearing,
      responsibility_and_initiative,
      organizing_ability,
      reliability,
      alertness_and_intelligence,
      behaviour_with_colleagues,
      knowledge_of_work,
    } = ratingData

    let total =
      parseInt(punctuality_attendance_and_time_keeping) +
      parseInt(devotion_to_duty) +
      parseInt(team_spirit) +
      parseInt(appearance_and_bearing) +
      parseInt(responsibility_and_initiative) +
      parseInt(organizing_ability) +
      parseInt(reliability) +
      parseInt(alertness_and_intelligence) +
      parseInt(behaviour_with_colleagues) +
      parseInt(knowledge_of_work)
    return total
  }

  const getSubmittedRating = () => {
    const {
      punctuality_attendance_and_time_keeping,
      devotion_to_duty,
      team_spirit,
      appearance_and_bearing,
      responsibility_and_initiative,
      organizing_ability,
      reliability,
      alertness_and_intelligence,
      behaviour_with_colleagues,
      knowledge_of_work,
    } = submittedRating

    let total =
      parseInt(punctuality_attendance_and_time_keeping) +
      parseInt(devotion_to_duty) +
      parseInt(team_spirit) +
      parseInt(appearance_and_bearing) +
      parseInt(responsibility_and_initiative) +
      parseInt(organizing_ability) +
      parseInt(reliability) +
      parseInt(alertness_and_intelligence) +
      parseInt(behaviour_with_colleagues) +
      parseInt(knowledge_of_work)
    return total
  }

  return (
    <>
      <div style={{ padding: '10px' }}>
        <table
          width="100%"
          className="table table-striped"
          style={{
            marginTop: '16px',
            borderCollapse: 'collapse',
            fontFamily: 'Arial, sans-serif',
          }}
        >
          <tbody>
            <tr>
              <th style={{ width: '70px' }}>Misc. Aspects</th>
              <th style={{ width: '24px' }}>Submitted Rating</th>
              <th style={{ width: '24px' }}>RATING FACTORS</th>
              <th style={{ width: '6px' }}>RATING</th>
            </tr>
            <tr>
              <td>
                <strong>Punctuality / Attendance & Time Keeping</strong>
              </td>
              <td>{submittedRating.punctuality_attendance_and_time_keeping}/10</td>
              <td>
                <RatingStars
                  count={10}
                  value={ratingData.punctuality_attendance_and_time_keeping}
                  onChange={(value) => onChange('punctuality_attendance_and_time_keeping', value)}
                  viewOnly={viewOnly}
                />
              </td>
              <td>
                <b style={{ color: 'blue' }} readOnly={viewOnly}>
                  {ratingData !== null
                    ? `${ratingData.punctuality_attendance_and_time_keeping}/10`
                    : ''}
                </b>
              </td>
            </tr>
            <tr>
              <td>
                <strong>Devotion to Duty</strong>
              </td>
              <td>{submittedRating.devotion_to_duty}/10</td>
              <td>
                <RatingStars
                  count={10}
                  value={ratingData.devotion_to_duty}
                  onChange={(value) => onChange('devotion_to_duty', value)}
                  viewOnly={viewOnly}
                />
              </td>
              <td>
                <b style={{ color: 'blue' }} readOnly={viewOnly}>
                  {ratingData !== null ? `${ratingData.devotion_to_duty}/10` : ''}
                </b>
              </td>
            </tr>
            <tr>
              <td>
                <strong>Team Spirit</strong>
              </td>
              <td>{submittedRating.team_spirit}/10</td>
              <td>
                <RatingStars
                  count={10}
                  value={ratingData.team_spirit}
                  onChange={(value) => onChange('team_spirit', value)}
                  viewOnly={viewOnly}
                />
              </td>
              <td>
                <b style={{ color: 'blue' }} readOnly={viewOnly}>
                  {ratingData !== null ? `${ratingData.team_spirit}/10` : ''}
                </b>
              </td>
            </tr>
            <tr>
              <td>
                <strong>Appearance & Bearing</strong>
              </td>
              <td>{submittedRating.appearance_and_bearing}/10</td>
              <td>
                <RatingStars
                  count={10}
                  value={ratingData.appearance_and_bearing}
                  onChange={(value) => onChange('appearance_and_bearing', value)}
                  viewOnly={viewOnly}
                />
              </td>
              <td>
                <b style={{ color: 'blue' }} readOnly={viewOnly}>
                  {ratingData !== null ? `${ratingData.appearance_and_bearing}/10` : ''}
                </b>
              </td>
            </tr>
            <tr>
              <td>
                <strong>Acceptance of Responsibility and initiative</strong>
              </td>
              <td>{submittedRating.responsibility_and_initiative}/10</td>
              <td>
                <RatingStars
                  count={10}
                  value={ratingData.responsibility_and_initiative}
                  onChange={(value) => onChange('responsibility_and_initiative', value)}
                  viewOnly={viewOnly}
                />
              </td>
              <td>
                <b style={{ color: 'blue' }} readOnly={viewOnly}>
                  {ratingData !== null ? `${ratingData.responsibility_and_initiative}/10` : ''}
                </b>
              </td>
            </tr>
            <tr>
              <td>
                <strong>Organizing Ability</strong>
              </td>
              <td>{submittedRating.organizing_ability}/10</td>
              <td>
                <RatingStars
                  count={10}
                  value={ratingData.organizing_ability}
                  onChange={(value) => onChange('organizing_ability', value)}
                  viewOnly={viewOnly}
                />
              </td>
              <td>
                <b style={{ color: 'blue' }} readOnly={viewOnly}>
                  {ratingData !== null ? `${ratingData.organizing_ability}/10` : ''}
                </b>
              </td>
            </tr>
            <tr>
              <td>
                <strong>Reliability</strong>
              </td>
              <td>{submittedRating.reliability}/10</td>
              <td>
                <RatingStars
                  count={10}
                  value={ratingData.reliability}
                  onChange={(value) => onChange('reliability', value)}
                  viewOnly={viewOnly}
                />
              </td>
              <td>
                <b style={{ color: 'blue' }} readOnly={viewOnly}>
                  {ratingData !== null ? `${ratingData.reliability}/10` : ''}
                </b>
              </td>
            </tr>
            <tr>
              <td>
                <strong>Mental Alertness & Intelligence</strong>
              </td>
              <td>{submittedRating.alertness_and_intelligence}/10</td>
              <td>
                <RatingStars
                  count={10}
                  value={ratingData.alertness_and_intelligence}
                  onChange={(value) => onChange('alertness_and_intelligence', value)}
                  viewOnly={viewOnly}
                />
              </td>
              <td>
                <b style={{ color: 'blue' }} readOnly={viewOnly}>
                  {ratingData !== null ? `${ratingData.alertness_and_intelligence}/10` : ''}
                </b>
              </td>
            </tr>
            <tr>
              <td>
                <strong>Behaviour with colleagues / customers</strong>
              </td>
              <td>{submittedRating.behaviour_with_colleagues}/10</td>
              <td>
                <RatingStars
                  count={10}
                  value={ratingData.behaviour_with_colleagues}
                  onChange={(value) => onChange('behaviour_with_colleagues', value)}
                  viewOnly={viewOnly}
                />
              </td>
              <td>
                <b style={{ color: 'blue' }} readOnly={viewOnly}>
                  {ratingData !== null ? `${ratingData.behaviour_with_colleagues}/10` : ''}
                </b>
              </td>
            </tr>
            <tr>
              <td>
                <strong>Knowledge of work</strong>
              </td>
              <td>{submittedRating.knowledge_of_work}/10</td>
              <td>
                <RatingStars
                  count={10}
                  value={ratingData.knowledge_of_work}
                  onChange={(value) => onChange('knowledge_of_work', value)}
                  viewOnly={viewOnly}
                />
              </td>
              <td>
                <b style={{ color: 'blue' }} readOnly={viewOnly}>
                  {ratingData !== null ? `${ratingData.knowledge_of_work}/10` : ''}
                </b>
              </td>
            </tr>
            <tr>
              <td>
                <b readOnly={viewOnly}>Overall Performance:</b>
              </td>
              <td style={{ color: 'green', fontWeight: 'bold' }}> {getSubmittedRating()} / 100</td>
              <td></td>
              <td style={{ color: 'green', fontWeight: 'bold' }}> {getTotalRating()} / 100</td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  )
}
